// extracted by mini-css-extract-plugin
export default {"main":"RouterComponent_main__GECTj","loadSpin":"RouterComponent_loadSpin__2E9Ey","spinner":"RouterComponent_spinner__IEyVo"};